import React from 'react';
import { HtmlString } from '@adjust/dashboard-components';

import { normalizeCreditCard } from '@lib/braintree/braintree';
import { CurrencyInfo, PaymentMethodData } from '@api/types';
import { TileWithLoading } from '@react/Pages/AccountSettingsPage/YourDataSection/TileWithLoading';

interface CardFieldProps {
  value: string;
  label: string;
}

const CardField: React.FC<CardFieldProps> = ({ label, value }) => (
  <div className="your-data-field-row__data">
    <div className="your-data-field-row__label">{label}</div>
    <div className="your-data-field-row__value">{value}</div>
  </div>
);

interface CreditCardTileProps {
  currency: CurrencyInfo;
  paymentMethod: Nullable<PaymentMethodData>;
  href: string;
}

const CreditCardTileBase: React.FC<CreditCardTileProps> = ({ paymentMethod, currency, href }) => {
  const cardType = paymentMethod && normalizeCreditCard(paymentMethod.cardType);

  return (
    <>
      <div className="your-data-card__title">{t('label.credit-card')}</div>
      <div className="your-data-card__body">
        {paymentMethod && (
          <div className="flex-one flex-box-column">
            <div className="your-data-field-row">
              <div className="your-data-field-row__icon">
                <i>{currency.symbol}</i>
              </div>
              <CardField label={t('label.currency')} value={currency.name} />
              <CardField label={t('label.expire')} value={paymentMethod.expiration} />
            </div>
            <div className="your-data-field-row">
              <div className="your-data-field-row__icon">
                <i className={`icon-${cardType}`} />
              </div>
              <CardField label={t('label.type')} value={paymentMethod.cardType} />
              <CardField label={t('label.card-number')} value={paymentMethod.maskedNumber} />
            </div>
          </div>
        )}

        {!paymentMethod && (
          <div className="your-data-card__empty-msg">
            <span>{t('credit-card.no-credit-card-found.message')}</span>
            <div className="your-data-card__empty-msg-instructions">
              <HtmlString>{t('credit-card.select.action')}</HtmlString>
            </div>
          </div>
        )}
      </div>
      <a className="your-data-card__action" href={href}>
        <i className="icon-cog" />
      </a>
    </>
  );
};

const CreditCardTile = TileWithLoading(CreditCardTileBase);

export default CreditCardTile;
